import { Icon } from "@elaniintc/goes-design-system";
import { Permissions } from "./permissions";

type DataGroup = {
  title: string;
  items: {
    title: string;
    url: string;
    icon: React.ReactNode;
  }[];
};

export const getMenuData = (hasPermission: (permission: string) => boolean) => {
  const resources: DataGroup = {
    title: "Recursos",
    items: [
      {
        title: "Inicio",
        url: "/",
        icon: (
          <Icon
            type="far"
            name="home"
            className="text-body! group-data-[active=true]:text-action! text-h6"
          />
        ),
      },
    ],
  };
  const administration: DataGroup = {
    title: "Administración",
    items: [],
  };

  const documentacion: DataGroup = {
    title: "Documentación",
    items: [
      {
        title: "Expedientes",
        url: "/expedientes",
        icon: (
          <Icon
            type="far"
            name="folder-open"
            className="text-body! group-data-[active=true]:text-action! text-h6"
          />
        ),
      },
    ],
  };
  /*
  const inspection: DataGroup = {
    title: "Inspección",
    items: [
      {
        title: "Finazas",
        url: "/finanzas",
        icon: (
          <Icon
            type="far"
            name="circle-dollar"
            className="text-body! group-data-[active=true]:text-action! text-h6"
          />
        ),
      },
      {
        title: "Reguladores",
        url: "/reguladores",
        icon: (
          <Icon
            type="far"
            name="users-rectangle"
            className="text-body! group-data-[active=true]:text-action! text-h6"
          />
        ),
      },
    ],
  };
  */

  if (hasPermission(Permissions.processes.read)) {
    resources.items.push({
      title: "Procesos",
      url: "/procesos",
      icon: (
        <Icon
          type="far"
          name="diagram-project"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }
  if (hasPermission(Permissions["data-center"].read)) {
    resources.items.push({
      title: "Centro de datos",
      url: "/centro-de-datos",
      icon: (
        <Icon
          type="far"
          name="database"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }

  if (
    hasPermission(Permissions["email-templates"].read) ||
    hasPermission(Permissions["document-templates"].read)
  ) {
    resources.items.push({
      title: "Plantillas",
      url: "/plantillas",
      icon: (
        <Icon
          type="far"
          name="notes-sticky"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }

  if (hasPermission(Permissions.roles.read)) {
    administration.items.push({
      title: "Roles",
      url: "/roles",
      icon: (
        <Icon
          type="far"
          name="user-shield"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }

  if (
    hasPermission(Permissions.users.read) ||
    hasPermission(Permissions["approval-groups"].read)
  ) {
    administration.items.push({
      title: "Usuarios",
      url: "/usuarios",
      icon: (
        <Icon
          type="far"
          name="users"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }

  if (hasPermission(Permissions.calendar.read)) {
    administration.items.push({
      title: "Calendario",
      url: "/calendario",
      icon: (
        <Icon
          type="far"
          name="calendar-clock"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }

  if (
    hasPermission(Permissions.announcements.read) ||
    hasPermission(Permissions.faqs.read)
  ) {
    administration.items.push({
      title: "Portal",
      url: "/portal",
      icon: (
        <Icon
          type="far"
          name="globe-pointer"
          className="text-body! group-data-[active=true]:text-action! text-h6"
        />
      ),
    });
  }

  return {
    ...(resources.items.length > 0 && { resources }),
    ...(administration.items.length > 0 && { administration }),
    ...(documentacion.items.length > 0 && { documentacion }),
    //...(inspection.items.length > 0 && { inspection }),
  };
};
